var map = {
	"./artificios_nao_recomendados.jpg": 80,
	"./caixas_termicas.jpg": 81,
	"./copinho.jpg": 82,
	"./desenhos_diversos.jpg": 83,
	"./desenhos_diversos2.jpg": 84,
	"./desenhos_diversos3.jpg": 85,
	"./equipamentos_amamentacao.jpg": 86,
	"./equipamentos_amamentacao2.jpg": 87,
	"./estimulo_manual.png": 88,
	"./final_da_mamada.jpg": 89,
	"./formas_adequadas.jpg": 90,
	"./formas_armazenar.jpg": 91,
	"./higienizacao_mamas.jpg": 92,
	"./mamas.png": 93,
	"./ordenha_manual.jpg": 94,
	"./ordenha_manual2.jpg": 95,
	"./pega_correta.jpg": 96,
	"./pega_correta2.jpg": 97,
	"./pega_correta3.jpg": 98,
	"./posicao_amamentar.jpg": 99,
	"./posicao_amamentar2.jpg": 100,
	"./posicao_amamentar3.jpg": 101,
	"./posicao_amamentar4.jpg": 102,
	"./posicao_amamentar5.jpg": 103,
	"./posicao_amamentar6.jpg": 104,
	"./tipos_mamilo.png": 105,
	"./vesicula_avancada.jpg": 106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;